export enum EmploymentType {
  PERMANENT = 'permanent',
  LIMITED = 'limited',
  SCHOOLING = 'schooling',
  DUAL_STUDY = 'dual-study',
  INTERNSHIP = 'internship',
  WORKING_STUDENT = 'working-student',
  TRAINEE = 'trainee',
  TEMPORARY = 'temporary',
  FREELANCER = 'freelancer',
  FEE_WORK = 'fee-work',
  VOLUNTEERING = 'volunteering',
  THESIS = 'thesis',
  BY_ARRANGEMENT = 'by-arrangement',
}
